/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungChecklisteDto } from '../../models/lexplus-anforderung-checkliste-dto';

export interface AnforderungDetailControllerGetAnforderungChecklisteV1$Params {
  anforderungsversionID: number;
  standortID?: number;
}

export function anforderungDetailControllerGetAnforderungChecklisteV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerGetAnforderungChecklisteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungChecklisteDto>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerGetAnforderungChecklisteV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.query('standortID', params.standortID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungChecklisteDto>;
    })
  );
}

anforderungDetailControllerGetAnforderungChecklisteV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/checkliste';
